// Number formatting constants
export const NUMBER_FORMATTING = {
  THRESHOLD: 1, // Threshold for determining decimal places
  DECIMAL_PLACES: {
    ABOVE_THRESHOLD: 3, // Decimal places for numbers >= threshold
    BELOW_THRESHOLD: 4, // Decimal places for numbers < threshold
  },
} as const;
